<template>
    <div class="text-data-config-viewer" :style="computedStyle">{{ item.text || 'Testo' }}</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class TextDataConfigViewer extends Vue {
    @Prop() item: OM.TextDataConfig;

    get computedStyle() {
        return {
            fontSize: (this.item.fontSize || 14) + 'px',
            fontFamily: this.item.fontFamily || 'Arial',
            color: this.item.color || '#000000',
            fontWeight: this.item.fontWeight || 'normal',
            textAlign: this.item.textAlign || 'left',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            minWidth: '20px',
            minHeight: '16px',
        };
    }
}
</script>
